import React from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import BackBtnIcon from './back-arrow.svg?react';
import styles from './back-button.module.scss';

const BackButton = ({
  text,
  onClick,
}: {
  text: string;
  onClick: () => void;
}) => {
  return (
    <Button
      leftIcon={<BackBtnIcon aria-label="back-btn" />}
      className={styles.backButton}
      onClick={onClick}
      variant={'text'}
    >
      {text}
    </Button>
  );
};

export default BackButton;
